module.exports = __webpack_public_path__ + "static/media/app-store-en.c6546a06.png";